import { useQuery, type UseQueryResult } from 'react-query';
import {
  CharterFilingService,
  type Wealthlane_CapTable_Dtos_CharterFiling_CharterFilingDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetCharterFilings = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<Wealthlane_CapTable_Dtos_CharterFiling_CharterFilingDto[] | undefined, unknown> => {
  return useQuery(
    ['getCharterFilings'],
    async () => {
      return await handleRequest(
        CharterFilingService.getApiCapTableApiAppCharterFilingCharterFilings()
      );
    }
  );
};

export default useGetCharterFilings;
